export default __webpack_public_path__ + "static/media/logo-AiVoice-studio.adb9945c.png";